import { AutogenModelTieredStop, AutogenRowTieredStop } from "./autogen/AutogenModelTieredStop";

export class ModelTieredStop extends AutogenModelTieredStop<RowTieredStop> {
	constructor() {
		super(RowTieredStop);
	}
}

export class RowTieredStop extends AutogenRowTieredStop {
}